<template>
  <div class="container">
    <!-- 所有任务 -->
    <!-- 头部 -->
    <div class="searchBox">
      <el-form :inline="true" size="mini" :model="searchForm">
        <div class="header">
          <el-form-item>
            <el-select multiple collapse-tags clearable filterable v-model="searchForm.project_id" placeholder="请选择产品"
              style="width:220px;" @change="changeProjectId" :size="size">
              <el-option v-for="item in projectList" :label="item.project_name + '(' + item.project_owner_name + ')'"
                :value="item.project_id" :key="item.project_id + '2'" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select :disabled="currentProjectId().length > 1 && currentProjectId().length !== 0"
              v-model="searchForm.pm_id" :size="size" placeholder="请选择模块" style="width:150px;"
              @change="changePmId(searchForm.project_id)" clearable>
              <el-option v-for="item in modleList" :label="item.pm_name" :value="item.pm_id" :key="item.pm_id" />
            </el-select>
          </el-form-item>

          <!-- <span>{{index}}{{item}}</span> -->
          <el-button v-if="role.seven === 7" type="primary" :size="size" @click="addTask()">新增任务</el-button>
          <el-button v-if="role.eight === 8" type="primary" :size="size" @click="changeStatus(1)">开始开发</el-button>
          <el-button v-if="role.nine === 9" type="primary" :size="size" @click="changeStatus(2)">提交测试</el-button>
          <el-button v-if="role.ten === 10" type="primary" :size="size" @click="changeStatus(3)">开始测试</el-button>
          <el-button v-if="role.eleven === 11" type="primary" @click="stopDialog(2)" :size="size">暂停</el-button>
          <el-button v-if="role.twelve === 12" type="primary" @click="changeStatus(5)" :size="size">继续</el-button>
          <el-button v-if="role.thirteen === 13" type="primary" @click="changeStatus(6)" :size="size">测试完成</el-button>
          <el-button v-if="role.fourteen === 14" type="primary" @click="stopDialog(1)" :size="size">废弃</el-button>
          <!-- 废弃/暂停 -->
          <el-dialog :visible.sync="stopVisibel" :title="stopTitle" width="900px" :close-on-click-modal="false">
            <el-form :model="stopForm" :rules="rules" ref="stopForm" class="dialogBox">
              <el-row>
                <el-form-item label="原因" style="line-height: 40px;" prop="reason">
                  <el-select v-model="stopForm.reason" style="width:500px" placeholder="请选择原因">
                    <el-option label="设计如此" value="设计如此" />
                    <el-option label="不做" value="不做" />
                    <el-option label="延期" value="延期" />
                    <el-option label="已细分" value="已细分" />
                    <el-option label="重复" value="重复" />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-form-item label="备注" style="line-height: 40px;" prop="note">
                <TipTapEditor v-if="stopVisibel" v-model="stopForm.note" />
                <!-- <Wangeditor v-model="stopForm.note" @change="decChange" /> -->
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="cancel">取 消</el-button>
              <el-button type="primary" @click="submitStop(2, 1)">提 交</el-button>
            </div>
          </el-dialog>
        </div>
        <!-- 搜索栏 -->

        <el-form-item label="任务ID">
          <el-input clearable v-model.number="searchForm.task_id" placeholder="ID" min="0" style="width:100px;" />
        </el-form-item>
        <el-form-item label="需求ID">
          <el-input clearable v-model.number="searchForm.demand_id" min="0" style="width:100px" placeholder="需求标题" />
        </el-form-item>

        <el-form-item label="处理人">
          <el-select v-model="searchForm.task_next_user" :remote-method="getUserInfoByNameProposer"
            :loading="selectLoading" @change="task_next_user_change" placeholder="请输入后选择" remote filterable
            reserve-keyword clearable>
            <el-option v-for="(from, fromIndex) in demandProposerList"
              :label="`${from.name}(${from.username})${(from.state !== 1 || from.status !== 1) ? '(不可用)' : ''}`"
              :value="from.userId" :key="fromIndex" />
          </el-select>
        </el-form-item>
        <el-form-item label="任务标题">
          <el-input clearable v-model="searchForm.task_name" placeholder="任务标题" />
        </el-form-item>
        <el-form-item label="待我处理">
          <el-checkbox v-model="searchForm.task_next_user_self" @change="task_next_user_self_change"></el-checkbox>
        </el-form-item>
        <el-form-item label="与我相关">
          <el-checkbox v-model="searchForm.customer_id" @change="customer_id_change"></el-checkbox>
        </el-form-item>

        <el-form-item class="actionBox" label=" ">
          <el-button-group>
            <el-button type="primary" @click="onSearch()">查询</el-button>
            <el-button type="warning" @click="clearSearch">清空</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <!-- 状态栏 -->
    <div class="status">
      <!--el-tag切换栏 start-->
      <el-row class="status">
        <el-tag :type="statusSelected(null)" size="small">
          <span @click="handleStatus(null)">所有任务 ({{ statusList[0] }})</span>
        </el-tag>
        <el-tag v-for="(name, index) in statusName" :key="index" :type="statusSelected(index)" size="small">
          <span @click="handleStatus(index)">{{ name }} ({{ statusList[index + 1] }})</span>
        </el-tag>
        <span class="mark_title">任务为：不需要测试或不需要验收，不允许在列表进行相关操作</span>
      </el-row>
      <!--el-tag切换栏 end-->
    </div>
    <!-- 列表栏 -->
    <div class="content">
      <el-table v-loading="tableLoading" :data="tableData" ref="tableData" border
        :default-sort="{ prop: 'task_id', order: 'descending' }" @selection-change="handleSelectionChange"
        height="calc(100vh - 210px)">
        <el-table-column type="selection" width="30" :selectable="selectableFn" />
        <el-table-column prop="task_id" label="任务ID" sortable width="90" align="center" />
        <el-table-column prop="level_name" label="优先级" width="80" align="center" />
        <el-table-column label="难度系数" align="center" width="80">
          <template slot-scope="scope">
            <span>{{ DegreeOfDifficultyList[scope.row.task_degree_of_difficulty] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="task_name" label="任务标题" min-width="250" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.demand_write_test_case == 0" effect="dark" :content="'不需要测试用例'" placement="top">
              <!-- <img src="@/assets/no_test_case_required.png" style="margin-bottom: -5.2px; margin-right: 4px;" alt=""> -->
              <section class="test_case_icon not_reviewed">
                <span>x用例</span>
              </section>
            </el-tooltip>
            <a class="titleColor" type="text" @click="toNewCheckTask(scope.row.task_id)">{{ scope.row.task_name }}</a>
            <div style="margin: 0; display: flex; align-items: center; justify-content: center;">
              <p>
                <el-tag :type="colors[index]" size="mini" v-for="(item, index) in scope.row.tag.slice(0, 4)"
                  :key="index">{{ item.name }}</el-tag>
              </p>
              <el-tag v-if="scope.row.tag.length > 4" size="mini"
                :title="scope.row.tag.map((item) => item.name).toString()">...</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="140" align="center">
          <template slot-scope="scope">
            <span>状态:{{ scope.row.status_name }}</span>
            <br />
            <span class="blueTxt">ETA:{{ scope.row.demand_plan_submit_time }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="task_next_user_name" label="相关人员" width="130">
          <template slot-scope="scope">
            <span>处理人:{{ scope.row.task_next_user_name }}</span>
            <br />
            <span>程序员:{{ scope.row.task_coding_user_name }}</span>

            <br />
            <span>测试员:{{ scope.row.task_test_user_name }}</span>

            <br />
            <span>创建人:{{ scope.row.task_creater_name }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="task_next_user_name" label="当前处理人" width="90" align="center"/>
        <el-table-column prop="task_coding_user_name" label="当前处理人" width="100" align="center"/>
        <el-table-column prop="task_test_user_name" label="测试工程师" width="100" align="center"/>-->
        <el-table-column prop="demand_id" label="需求ID" flex="1" width="90" align="center">
          <template slot-scope="scope">
            <router-link target="_blank"
              :to="{ path: '/alldemand/newCheckDemand', query: { 'demand_id': scope.row.demand_id } }">
              <span style="color:blue">{{ scope.row.demand_id }}</span>
            </router-link>
          </template>
        </el-table-column>

        <el-table-column prop="task_coding_time" label="工时(小时)" width="110">
          <template slot-scope="scope">
            <span>开发预计:{{ scope.row.task_coding_time?scope.row.task_coding_time.toFixed(1):'' }}</span>
            <br />
            <span>开发实际:{{ scope.row.coding_practical_time?scope.row.coding_practical_time.toFixed(1):'' }}</span>

            <br />
            <span>测试预计:{{ scope.row.task_test_time?scope.row.task_test_time.toFixed(1):'' }}</span>

            <br />
            <span>测试实际:{{ scope.row.test_practical_time?scope.row.test_practical_time.toFixed(1):'' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="开发时间" width="220">
          <template slot-scope="scope">
            <span>计划开始:{{ scope.row.task_plan_start_date }}</span>
            <br />
            <span>计划完成:{{ scope.row.task_plan_complete_date }}</span>
            <br />
            <span>实际开始:{{ scope.row.task_coding_start_date }}</span>
            <br />
            <span>实际完成:{{ scope.row.task_coding_end_date }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="时间" width="220">
          <template slot-scope="scope">
            <span>测试开始:{{ scope.row.task_test_start_date }}</span>
            <br />
            <span>测试完成:{{ scope.row.task_test_complete_date }}</span>
            <br />
            <span>上次驳回:{{ scope.row.task_reject_date }}</span>
            <br />
            <span>创建时间:{{ scope.row.task_create_date }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="task_creater_name" label="创建人" width="80" align="center"/> -->
        <!-- <el-table-column prop="task_create_date" label="创建时间" width="200" align="center"/> -->
        <!-- <el-table-column prop="pv_status" label="是否已发布" width="90" align="center"/> -->
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <!-- <span v-for="(item,index) in scope.row.roleList :key=index"> -->
            <el-button type="text" size="mini" @click="editTask(scope.row.task_id)"
              v-show="scope.row.pv_status != '已发布' && role.one == 1">编辑任务</el-button>
            <!-- 测试 -->
            <el-button type="text" size="mini" v-show="showWorkTimebtn('testTime', scope.row)"
              @click="workingHours(scope.row, 1)">测试记录工时</el-button>
            <!-- 开发 -->
            <el-button type="text" size="mini" v-show="showWorkTimebtn('coderTime', scope.row)"
              @click="workingHours(scope.row, 0)">开发记录工时</el-button>
            <!-- 测试 -->
            <el-button type="text" size="mini" v-show="showWorkTimebtn('testEditTime', scope.row)"
              @click="editHoursList(scope.row, 1)">测试编辑工时</el-button>
            <!-- 开发 -->
            <el-button type="text" size="mini" v-show="showWorkTimebtn('coderEditTime', scope.row)"
              @click="editHoursList(scope.row, 0)">开发编辑工时</el-button>
            <el-button type="text" size="mini" @click="rejected(scope.row.task_id)"
              v-show="scope.row.pv_status != '已发布' && role.six == 6 && scope.row.task_status === 4">驳回到开发</el-button>
            <!-- <el-button
                type="success"
                size="mini"
                @click="$router.push({path :'/allTask/checkTask',query:{'task_id':scope.row.task_id}})"
            >查看</el-button>-->
            <!-- </span> -->

            <!-- <el-tooltip class="item" effect="dark" content="编辑" placement="bottom-start">
               <el-button
              type="text"
              size="mini"
              @click="editTask(scope.row.task_id)"
              v-show="scope.row.pv_status != '已发布'  && role.one == 1"
            >
              <i class="iconfont icon-bianji1"></i>
              </el-button>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="记录开发工时" placement="bottom-start">
                  <el-button
                  type="text"
                  v-show="scope.row.pv_status != '已发布'  && role.five == 5"
                  @click="workingHours(scope.row.task_id,0),WorkingHours = true"
                >
                <i class="iconfont icon-jilu"></i>
                </el-button>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="记录测试工时" placement="bottom-start">
                  <el-button
              type="text"
              v-show="scope.row.pv_status != '已发布'  && role.two ==2"
              @click="workingHours(scope.row.task_id,1),WorkingHours = true"
            >
             <i class="iconfont icon-edit"></i>
            </el-button>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="编辑开发工时" placement="bottom-start">
                  <el-button
              type="text"
              size="mini"
              v-show="scope.row.pv_status != '已发布' && role.four == 4"
              @click="editHoursList(scope.row.task_id,0),editHours = true"
            >
             <i class="iconfont icon-bianjiedit26"></i>
            </el-button>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="编辑测试工时" placement="bottom-start">
                 <el-button
              type="text"
              size="mini"
              v-show="scope.row.pv_status != '已发布' && role.three == 3"
              @click="editHoursList(scope.row.task_id,1),editHours = true"
            >
            <i class="iconfont icon-20"></i>
            </el-button>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="驳回到开发" placement="bottom-start">
                <el-button
              type="text"
              size="mini"
              @click="rejected(scope.row.task_id)"
              v-show="scope.row.pv_status != '已发布' && role.six == 6"
            >
            <i class="iconfont icon-xianshi_quxiaotianchong"></i>
            </el-button>
            </el-tooltip>

             <el-tooltip class="item" effect="dark" content="查看" placement="bottom-start">
              <el-button
              type="text"
              @click="$router.push({path :'/allTask/checkTask',query:{'task_id':scope.row.task_id}})"
            >
            <i class="iconfont icon-chakan"></i>
            </el-button>
            </el-tooltip>-->
          </template>
        </el-table-column>
      </el-table>
      <!-- 工时 -->
      <el-dialog :visible.sync="WorkingHours" :title="hoursTitle" width="1080px" :close-on-click-modal="false">
        <el-form ref="recordWorkingHours" :model="recordWorkingHours" :inline="true" label-width="100px" size="mini">
          <!-- :label="'序号' + index" -->
          <el-row v-for="(domain, index) in recordWorkingHours.domains" :key="index + 'a'">
            <!-- <el-form-item :label="index+1" label-width="150px"/> -->
            <span>{{ index + 1 }}</span>
            <el-form-item :prop="'domains.' + index + '.tt_coding_start_date'" :rules="[{
              required: true, message: '日期不能为空', trigger: 'blur'
            }]" label="日期">
              <el-date-picker @focus="datePickerFocus" v-model="domain.tt_coding_start_date"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd" type="date"
                @change="changeWorkingDate($event, domain, index)" placeholder="选择日期" style="width:150px;" />
            </el-form-item>
            <el-form-item :prop="'domains.' + index + '.tt_coding_time'" :rules="[{
              required: true, message: '消耗工时不能为空', trigger: 'blur'
            }]" label="消耗工时">
              <el-input-number :max="12" :min="0.1" :step="0.1" @blur="changeHours" @input.native="inputHours"
                v-model.number="domain.tt_coding_time" style="width:100px;" />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="domain.tt_note" style="width:300px;" />
            </el-form-item>
            <el-button @click.prevent="removeDomain(domain, index)" size="mini">删除</el-button>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDomain" size="mini">新增一行</el-button>
          <el-button type="primary" :disabled="disabledSaveWoringTimeBtn" :loading="saveLoading" size="mini"
            @click="submitForm('recordWorkingHours')">保存</el-button>
          <el-button @click="resetForm('recordWorkingHours'), WorkingHours = false" size="mini">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="editHours" :title="hoursTitle" width="900px" :close-on-click-modal="false">
        <div class="editHours">
          <el-table :data="workHorusData" height="500px">
            <el-table-column property="tt_id" label="ID" width="150" />
            <el-table-column property="tt_coding_start_date" label="日期" width="150" />
            <el-table-column property="tt_coding_time" label="工时" width="200" />
            <el-table-column property="tt_note" label="备注" />
            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="editHoursData(scope.row)">编辑</el-button>
                <el-button type="text" size="mini"
                  @click="deleteHours(scope.row.tt_id, scope.row.task_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editHours = false">取消</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="hoursData" title="编辑工时表单" :close-on-click-modal="false">
        <el-form :model="hoursDataForm">
          <el-form-item :label-width="formLabelWidth" label="日期">
            <el-date-picker disabled v-model="hoursDataForm.tt_coding_start_date" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期" style="width:400px;" />
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="消耗工时">
            <el-input-number :max="12" :min="0.1" :step="0.1" @blur="changeHours" @input.native="inputHours"
              v-model.number="hoursDataForm.tt_coding_time" style="width:400px;" />
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="备注">
            <el-input v-model="hoursDataForm.tt_note" style="width:400px;" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hoursData = false">取 消</el-button>
          <el-button type="primary" @click="submitHoursData" :loading="submitLoading">提 交</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="pageBox">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  taskSelect,
  recordHours,
  hoursList,
  updateStatus,
  listBtn,
  editHoursList
} from '@/api/allTask'
import Tinymce from '@/components/Tinymce'
// import Wangeditor from '@/components/Wangeditor'
import { deepClone, getUserNameEmail } from '@/utils/index'
import { getProjectList, getModelList, writingUseCases, taskisDiscard } from '@/api/demand'
import {
  getUserInfoById,
  getUserInfoByName,
  getUserInfoByIdList
} from '@/api/login'

export default {
  name: 'TinymceDemo',
  components: { Tinymce },
  data() {
    return {
      chooseDiscard: '0',
      lastTask: false,
      // pageBox
      pageNum: 1,
      pageSize: 20,
      total: 0,
      // 暂停/废弃框
      stopVisibel: false,
      stopForm: {
        note: null,
        reason: '',
        email: ''
      },
      multipleSelection: [],
      statusTxt: '',
      // 工时
      recordWorkingHours: {
        domains: [
          {
            tt_coding_start_date: '',
            tt_coding_time: '',
            tt_note: ''
          }
        ]
      },
      taskId: '',
      WorkingHours: false,
      editHours: false,
      workHorusData: [],
      taskIdList: [],
      status: '',
      formLabelWidth: '120px',
      // search
      projectList: [],
      searchForm: {
        task_status: null,
        task_id: '',
        task_name: '',
        demand_id: '',
        project_id: [],
        pm_id: '', // 模块id
        task_next_user: '', // 当前处理人
        customer_id: false, // 与我有关传0跟1 ，打勾传1
        task_next_user_self: true, // 与我有关传0跟1 ，打勾传1
        pageSize: 20
      },
      checked: true,
      projectId: [],
      modleList: [],
      role: {},
      date1: '',
      date2: '',
      searchBox: false,
      statusList: [],
      // content
      tableData: [],
      tableLoading: false,
      demandProposerList: [], // 需求提出人
      formeList: [], // 与我有关
      hoursData: false,
      hoursDataForm: {},
      responseData: [],
      stopTitle: '',
      hoursTitle: '',
      statusId: '',
      roleList: [],
      type: '',
      selectLoading: false,
      // urlInfo: "",
      statusName: [
        '待开发',
        '开发中',
        '开发暂停',
        '待测试',
        '测试中',
        '测试暂停',
        '测试完成',
        '废弃'
      ],
      DegreeOfDifficultyList: [
        '未设置',
        '普通',
        '一般',
        '中等',
        '困难',
        '挑战'
      ],
      key: '',
      rules: {
        reason: [{ required: true, message: '请填写原因', trigger: 'change' }],
        note: [{ required: true, message: '请填写说明', trigger: 'blur' }]
      },
      colors: ['', 'success', 'warning', 'danger', 'info'],
      disabledSaveWoringTimeBtn: false,
      inputHourValue: 0,
      saveLoading: false,
      submitLoading: false,
      pickerOptions: {}
    }
  },
  computed: {
    ...mapGetters(['size', 'userId', 'urlInfo'])
  },
  created() { },
  mounted() {
    this.getList()
  },
  methods: {
    addTestcase(demand_id, demand_dev_lead) {
      let id = JSON.parse(sessionStorage.getItem('urlInfo')).userId
      if (demand_dev_lead !== id) {
        this.$message.error('你不是此需求的开发组长，不允许操作')
        return
      }
      this.$prompt('标记原因', '标记用例修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if (instance.inputValue) done()
            else this.$message.error('标记原因不能为空')
          } else {
            done()
          }
        }
      }).then(({ value }) => {
        this.testFunc(demand_id, value)
      }).catch(() => {
      })
    },
    testFunc(demand_id, hasRemark) {
      const obj = {
        "demand_id": demand_id, 	//需求ID
        "test_case": "1",	//是否需要编写测试用例，0否，1是
        "user_id": this.userId,//用户ID
        // "dl_remark"	:""		//标记用例修改，选否的时候需要填写
      }
      if (hasRemark) obj.dl_remark = hasRemark
      writingUseCases(obj).then(res => {
        this.$message({
          type: 'success',
          message: '取消成功!'
        })
        this.getTaskList()
      })
    },
    removeTestcase(demand_id, dev_lead) {
      let id = JSON.parse(sessionStorage.getItem('urlInfo')).userId
      if (dev_lead !== id) {
        this.$message.error('你不是此需求的开发组长，不允许操作')
        return
      }
      this.$confirm('是否取消【不需要编写测试用例】的标记?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.testFunc(demand_id)
      }).catch(() => {
      });
    },
    currentProjectId() {
      if (this.searchForm.project_id.includes(0)) {
        return this.projectId
      }
      return this.searchForm.project_id
    },
    relatedToMe() {
      // this.searchForm.user_id = true;
    },
    // 点击选中tags切换颜色
    handleStatus(key) {
      this.key = null
      this.searchForm.task_status = key
      this.pageNum = 1

      this.getTaskList()
    },
    statusSelected(key) {
      return this.searchForm.task_status === key ? 'warning' : ''
    },
    getUserInfoByNameProposer(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then(res => {
          this.demandProposerList = res.data.list
          this.selectLoading = false
        })
      }
    },
    getUserInfoByNameforme(query) {
      if (query !== '') {
        this.selectLoading = true
        const params = {
          name: query,
          pageNum: 1,
          pageSize: 10
        }
        getUserInfoByName(params).then(res => {
          this.formeList = res.data.list
          this.selectLoading = false
        })
      }
    },

    getList() {
      const urlList = this.$store.getters.actionUrl
      for (let i = 0; i < urlList.length; i++) {
        this.roleList.push(urlList[i].url)
        switch (urlList[i].url) {
          case '/allTask/editTask':
            this.role.one = 1 // 编辑
            // console.log(111, this.role);
            break
          case '/allTask/testRecordingHours':
            this.role.two = 2 // (测试记录)
            // console.log(222, this.role);
            break
          case '/allTask/testEditHours':
            this.role.three = 3 // (测试编辑)
            // console.log(333, this.role);
            break
          case '/allTask/developmentEditHours':
            this.role.four = 4 // (开发)编辑
            // console.log(444, this.role);
            break
          case '/allTask/developmentRecordingHours':
            this.role.five = 5 // (开发)记录
            // console.log(555, this.role);
            break
          case '/allTask/rejectedToDevelopmen':
            this.role.six = 6 // 驳回开发
            // console.log(666, this.role);
            break
          case '/allTask/addTask':
            this.role.seven = 7 // 新增
            break
          case '/allTask/developmentStart':
            this.role.eight = 8 // 开始开发
            break
          case '/allTask/submitTest':
            this.role.nine = 9 // 提交测试
            break
          case '/allTask/startTesting':
            this.role.ten = 10 // 开始测试
            break
          case '/allTask/stop':
            this.role.eleven = 11 // 暂停
            break
          case '/allTask/continue':
            this.role.twelve = 12 // 继续
            break
          case '/allTask/finishedTest':
            this.role.thirteen = 13 // 测试完成
            break
          case '/allTask/discardTask':
            this.role.fourteen = 14 // 废弃
            break
        }
      }

      // console.log("url", this.role);

      // console.log("role", this.role);
      getProjectList(this.userId)
        .then(response => {
          // console.log( '999', this.searchForm);
          // console.log("form",this.$store.getters.search_form);
          this.projectList = response.data.projectIds
          // this.searchForm.task_next_user = this.userId;
          // getUserInfoById(this.searchForm.task_next_user).then(res => {
          //   this.demandProposerList.push(res.data);
          // });
          // this.projectId = this.projectList[0].project_id;
          if (this.projectList.length === 0) {
            this.searchForm.project_id = [0]
          } else {
            const allProject = [{ project_name: '全部产品', project_id: 0, project_owner_name: '' }]
            for (const i of allProject) {
              this.projectList.unshift(i)
            }
            const userIds = []
            for (const i in this.projectList) {
              if (this.projectList[i].project_id !== '') {
                this.projectId.push(this.projectList[i].project_id)
                userIds.push(this.projectList[i].project_owner)
              }
            }
            // 所有产品加上产品负责人显示
            getUserInfoByIdList({
              userIds: userIds
            }).then(res => {
              const userData = res.data
              for (const i in this.projectList) {
                for (const j in userData) {
                  if (this.projectList[i].project_owner === userData[j].userId) {
                    this.$set(this.projectList[i], 'project_owner_name', userData[j].name)
                  }
                }
              }
            })
            // 所有产品加上产品负责人显示
            // allProject[0].project_id = JSON.stringify(this.projectId)
            if (sessionStorage.getItem('allTask') != null) {
              // alert('key 存在')
              this.searchForm = JSON.parse(this.$store.getters.allTask)
              // for (const i in this.projectList) {
              //   if (
              //     this.projectList[i].project_id ===
              //     JSON.parse(sessionStorage.getItem('allTask')).project_id
              //   ) {
              //     this.searchForm.project_id = JSON.parse(
              //       this.$store.getters.allTask
              //     ).project_id
              //     break
              //   } else {
              //     // console.log(22);

              //     // this.searchForm.project_id = allProject[0].project_id
              //     this.searchForm.project_id = [0]
              //   }
              // }
            } else {
              // console.log("22", this.searchForm);
              // alert('key 不存在')
              // this.searchForm.project_id = allProject[0].project_id
              this.searchForm.project_id = [0]
            }
            // console.log("33", this.searchForm.task_next_user);

            // this.searchForm.task_next_user = this.userId;
            if (
              this.searchForm.task_next_user !== this.userId &&
              this.searchForm.task_next_user !== ''
            ) {
              console.log('aa')

              getUserInfoById(this.searchForm.task_next_user).then(res => {
                this.demandProposerList.push(res.data)
              })
            }
            // else {
            //   console.log("bb");
            //   getUserInfoById(this.searchForm.task_next_user).then(res => {
            //     this.demandProposerList.push(res.data);
            //   });
            // }
            // if (this.searchForm.user_id !== "") {
            //   console.log(11);

            //   getUserInfoById(this.searchForm.user_id).then(res => {
            //     this.formeList.push(res.data);
            //   });
            // }

            // 获取列表
            const params = {
              // project_id: this.searchForm.project_id
              project_id: this.currentProjectId()
            }
            // params.project_id = JSON.parse(params.project_id)
            getModelList(params)
              .then(response => {
                this.modleList = response.data
              })
              .catch(error => {
                console.log(error)
              })
            const allModle = [{ pm_name: '全部模块', pm_id: '' }]
            for (const i of allModle) {
              this.modleList.push(i)
            }
            // this.searchForm = JSON.parse(localStorage.getItem('searchForm'))
            this.onSearch()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeStatus(statusId) {
      // console.log(statusId);
      if (statusId === 1) {
        this.statusTxt = '开始开发'
        // console.log(statusId);
      } else if (statusId === 2) {
        this.statusTxt = '提交测试'
        // console.log(statusId);
      } else if (statusId === 3) {
        this.statusTxt = '开始测试'
      } else if (statusId === 4) {
        this.statusTxt = '暂停'
      } else if (statusId === 5) {
        this.statusTxt = '继续'
      } else if (statusId === 6) {
        this.statusTxt = '测试完成'
      }
      this.taskIdList = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.taskIdList.push(this.multipleSelection[i].task_id)
      }

      if (this.multipleSelection.length === 0) {
        this.stopVisibel = false
        this.$message({
          message: '请先选择对应的任务!',
          type: 'warning'
        })
      } else {
        // console.log("val", this.taskIdList);
        this.$confirm(`是否${this.statusTxt}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            const params = {
              user_id: this.userId,
              task_id: this.taskIdList,
              status: statusId
            }
            // console.log(params);
            listBtn(params)
              .then(response => {
                this.$store.commit(
                  'SET_ALLTASK',
                  JSON.stringify(this.searchForm)
                )
                // console.log(response);
                this.$message({
                  type: 'success',
                  message: `已${this.statusTxt}!`
                })
                this.onSearch()
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: `已取消${this.statusTxt}!`
            })
          })
      }
    },
    // 关闭/暂停
    stopDialog(status) {
      // console.log(status);

      this.taskIdList = []
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.taskIdList.push(this.multipleSelection[i].task_id)
      }
      // console.log("val", this.taskIdList);
      if (this.multipleSelection.length > 1) {
        this.$message({
          message: '为避免操作失误，废弃任务，请单个操作',
          type: 'warning'
        })
        return
      }
      if (this.multipleSelection.length === 0) {
        this.stopVisibel = false
        this.$message({
          message: '请先选择对应的任务!',
          type: 'warning'
        })
      } else {
        // this.stopVisibel = true
        // this.status = status
        if (status === 1) {
          const obj = {
            task_id: [this.multipleSelection[0].task_id]
          }
          taskisDiscard(obj).then(res => {
            if (res.data.is_discard === 0) {
              this.stopVisibel = true
              this.status = status
              this.lastTask = false
            } else {
              const h = this.$createElement;
              console.log(h, 666)
              let msgbox = this.$msgbox({
                title: '提示',
                message: h('div', { class: 'abc' }, [
                  h('p', null, '废弃此任务会同时废弃需求，是否同意？'),
                  h('span', {
                    on: {
                      click: this.cancelDiscard
                    },
                    class: 'el-button el-button--default el-button--small tobottom'
                  }, '取消'),
                ]),
                showCancelButton: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                customClass: 'hideicon',
                confirmButtonText: '确定',
                cancelButtonText: '否',
                type: 'warning'
              }).then(() => {
                this.stopVisibel = true
                this.status = status
                this.lastTask = true
                this.chooseDiscard = '1'
              }).catch(() => {
                this.stopVisibel = true
                this.status = status
                this.lastTask = true
                this.chooseDiscard = '0'
              })
            }
          })
        }

      }
      if (status === 1) {
        this.stopTitle = '废弃'
      } else {
        this.stopTitle = '暂停'
        this.stopVisibel = true
        this.status = status
      }
    },
    cancelDiscard() {
      this.$msgbox.close()
      this.$message({
        type: 'info',
        message: '已取消废弃'
      })
      this.stopVisibel = false
      this.chooseDiscard = '0'
      this.lastTask = false
    },
    submitStop() {
      this.$refs.stopForm.validate(valid => {
        if (valid) {
          const params = {
            user_id: this.userId,
            type: this.status,
            reason: this.stopForm.reason,
            note: this.stopForm.note,
            task_id: this.taskIdList,
            is_discard: this.chooseDiscard
            // system_code: this.urlInfo.systemCode
            // 废弃
          }
          updateStatus(params)
            .then(response => {
              // console.log(response.data);
              this.stopForm = {
                note: undefined,
                reason: ''
              }
              this.taskIdList = []
              this.stopVisibel = false
              this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
              this.onSearch()
              this.$message({
                message: '提交成功',
                type: 'success'
              })
            })
            .catch(error => {
              console.log(error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // console.log(this.stop,this.discard);
    },
    changeProjectId(statusId) {
      if (statusId.length > 0 && statusId[statusId.length - 1] === 0) {
        this.searchForm.project_id = [0]
      }
      if (this.searchForm.project_id.includes(0) && this.searchForm.project_id.length > 1) {
        this.searchForm.project_id = this.searchForm.project_id.filter(item => item !== 0)
      }
      this.searchForm.pm_id = ''

      const params = {
        // project_id: this.searchForm.project_id
        project_id: this.currentProjectId()
        // task_next_user:this.searchForm.task_next_user
      }
      getModelList(params)
        .then(response => {
          this.modleList = response.data
          // console.log(response.data);
          // console.log("id", this.searchForm.project_id);
        })
        .catch(error => {
          console.log(error)
        })

      // 获取所有任务列表
      this.onSearch()
    },
    changePmId(projectId) {
      this.onSearch()
    },
    // search查询
    onSearch() {
      this.pageNum = 1
      this.getTaskList()
    },
    getTaskList() {
      this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
      const params = deepClone(this.searchForm)
      // params.project_id = JSON.parse(params.project_id)
      params.project_id = this.currentProjectId()
      params.system_code = this.urlInfo.systemCode
      params.task_next_user = this.searchForm.task_next_user_self ? this.userId : this.searchForm.task_next_user
      if (!this.searchForm.customer_id) {
        params.customer_id = 0
      } else {
        params.customer_id = this.userId
      }
      params.current = this.pageNum
      params.pageSize = this.pageSize
      this.statusList = []
      this.tableData = []
      this.tableLoading = true
      taskSelect(params)
        .then(response => {
          let responseData = response.data
          let statusList = response.status_total
          for (const i in statusList[0]) {
            this.statusList.push(statusList[0][i])
          }
          this.total = response.total
          if (responseData.length > 0) {
            const keys = ['task_coding_user', 'task_test_user', 'task_next_user', 'task_creater']
            getUserNameEmail(keys, responseData).then(resd => {
              console.log(resd, 666)

              this.tableData = resd || []
              this.tableLoading = false
            }).catch(() => {
              this.tableData = []
              this.tableLoading = false
            })
          } else {
            this.tableData = []
            this.tableLoading = false
          }
        })
        .catch(error => {
          console.log(777)

          this.tableLoading = false
          console.log(error)
        })
    },
    // 清空
    clearSearch() {
      this.searchForm.task_id = ''
      this.searchForm.demand_id = ''
      this.searchForm.task_name = ''
      this.searchForm.task_next_user = ''
      this.searchForm.task_status = null
      // this.searchForm.user_id = "";
      this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
      this.onSearch()
    },
    // 状态栏
    statusBox(statusId) {
      // this.searchForm.task_status = statusId;
      // this.statusId = statusId;

      this.searchForm.task_status = statusId

      this.onSearch()
      // console.log(params);
    },
    // content
    // 记录工时
    async workingHours(row, typeId) {
      console.log("workingHours", row, typeId, this.userId);
      if ((!typeId && row.task_creater !== this.userId && row.task_coding_user !== this.userId) || (typeId && row.task_creater !== this.userId && row.task_test_user !== this.userId)) {
        // if(true){
        const res = await new Promise((resolve, reject) => {
          this.$confirm(`你不是本任务的${typeId === 1 ? '测试' : '开发'}负责人，确定要记录工时？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve(true)
          }).catch(() => {
            resolve(false)
          })
        }).then(res => res)
        if (!res) return
      }
      this.taskId = row.task_id
      this.type = typeId
      if (typeId === 1) {
        this.hoursTitle = '记录测试工时'
      }
      if (typeId === 0) {
        this.hoursTitle = '记录开发工时'
      }
      this.recordWorkingHours.domains = [
        {
          tt_coding_start_date: '',
          tt_coding_time: '',
          tt_note: ''
        }
      ]
      this.WorkingHours = true
    },
    submitForm() {
      this.saveLoading = true
      const submitObj = {
        user_id: this.userId,
        tt_type: this.type, // 0开发 1测试 必填
        task_id: this.taskId,
        task_tims: 1,
        tt_coding_start_date: [],
        tt_coding_time: [],
        tt_note: []
      }
      for (const i of this.recordWorkingHours.domains) {
        // console.log('list',i)
        submitObj.tt_coding_start_date.push(i.tt_coding_start_date)
        submitObj.tt_coding_time.push(i.tt_coding_time)
        submitObj.tt_note.push(i.tt_note)
      }
      this.$refs.recordWorkingHours.validate(valid => {
        if (valid) {
          // console.log("结果", submitObj);
          recordHours(submitObj)
            .then(response => {
              // console.log(response.data);
              this.recordWorkingHours.domains = [
                {
                  tt_coding_start_date: '',
                  tt_coding_time: '',
                  tt_note: ''
                }
              ]
              this.$message({
                message: '记录工时成功~',
                type: 'success'
              })
              this.WorkingHours = false
              this.saveLoading = false
              this.onSearch()
            })
            .catch(error => {
              this.saveLoading = false
              console.log(error)
            })
        } else {
          this.saveLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    cancel() {
      this.stopForm = {
        note: '',
        reason: '',
        email: ''
      }
      this.stopVisibel = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      // console.log("val",val);
    },
    async editHoursList(row, typeId) {

      if ((!typeId && row.task_creater !== this.userId && row.task_coding_user !== this.userId) || (typeId && row.task_creater !== this.userId && row.task_test_user !== this.userId)) {
        // if(true){
        const res = await new Promise((resolve, reject) => {
          this.$confirm(`你不是本任务的${typeId === 1 ? '测试' : '开发'}负责人，确定要记录工时？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve(true)
          }).catch(() => {
            resolve(false)
          })
        }).then(res => res)
        if (!res) return
      }
      this.type = typeId
      if (typeId === 1) {
        this.hoursTitle = '编辑测试工时'
      }
      if (typeId === 0) {
        this.hoursTitle = '编辑开发工时'
      }

      hoursList(row.task_id, typeId)
        .then(response => {
          // console.log(response.data);
          this.workHorusData = response.data || []
          this.editHours = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 编辑工时
    editHoursData(rowdata) {
      this.hoursData = true
      const params = {
        task_id: rowdata.task_id,
        tt_id: rowdata.tt_id,
        tt_coding_start_date: rowdata.tt_coding_start_date,
        tt_coding_time: rowdata.tt_coding_time,
        tt_note: rowdata.tt_note,
        update_task_tims: 1,
        tt_type: this.type, // 0开发 1测试 必填
        user_id: this.userId
      }
      this.hoursDataForm = params
    },

    submitHoursData() {
      // console.log("params",this.hoursDataForm);
      this.submitLoading = true
      editHoursList(this.hoursDataForm)
        .then(response => {
          // console.log(response.data);
          this.$message({
            message: '编辑工时成功~',
            type: 'success'
          })
          this.editHoursList(this.hoursDataForm.task_id)
          this.hoursData = false
          this.submitLoading = false
          this.onSearch()
        })
        .catch(error => {
          this.submitLoading = false
          console.log(error)
        })
    },
    // 删除工时
    deleteHours(ttId, taskId) {
      const params = {
        delete_task_tims: 1,
        tt_id: ttId,
        user_id: this.userId
      }
      // console.log("taskid",taskId);
      this.$confirm('此操作将删除该工时, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          editHoursList(params)
            .then(response => {
              // console.log(response.data);
              this.$message({
                message: '删除工时成功~',
                type: 'success'
              })
              // console.log("taskid", taskId);

              this.editHoursList(taskId)

              this.onSearch()
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    removeDomain(item, index) {
      // var index = this.recordWorkingHours.domains.indexOf(item)
      if (index !== -1) {
        this.recordWorkingHours.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.recordWorkingHours.domains.push({
        tt_coding_start_date: '',
        tt_coding_time: '',
        tt_note: ''
      })
    },
    filterHandler(value, row, column) {
      const property = column.property
      return row[property] === value
    },
    // 传taskid
    addTask() {
      this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
      this.$router.push({ name: 'addTask' })
    },
    editTask(taskId) {
      this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
      // let routeUrl = this.$router.resolve({
      //   path: "/allTask/editTask",
      //   query: { task_id: taskId }
      // });
      // window.open(routeUrl.href, "_blank");

      this.$router.push({
        path: '/allTask/editTask',
        query: { task_id: taskId }
      })
    },
    rejected(taskId) {
      this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
      this.$router.push({
        path: '/allTask/rejectedToDevelopmen',
        query: { task_id: taskId }
      })
      // this.$router.push("rejectedToDevelopmen");
    },
    // pageBox
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.pageNum = 1
      this.getTaskList()
      this.$refs.tableData.bodyWrapper.scrollTop = 0
    },
    handleCurrentChange(page) {
      this.pageNum = page
      this.getTaskList()
    },
    //

    // 跳转到查看任务
    toNewCheckTask(task_id) {
      this.$store.commit('SET_ALLTASK', JSON.stringify(this.searchForm))
      // this.$router.push({
      //   path: '/allTask/newCheckTask',
      //   query: { task_id: task_id }
      // })

      const routeUrl = this.$router.resolve({
        path: '/allTask/newCheckTask', // 新页面地址
        query: { task_id: task_id }// 携带的参数
      })
      window.open(routeUrl.href, '/allTask/newCheckTask')
    },
    task_next_user_self_change(val) {
      // 逻辑：取值为各状态下处理人里有“我”（即登录人）的数据，与处理人选中互斥 勾了处理人就是自己，原处理人若有数据清掉
      if (val) {
        this.searchForm.task_next_user = ''
        this.searchForm.customer_id = false
      }
    },
    customer_id_change(val) {
      // 逻辑：待我处理和与我相关 只能勾选一个
      if (val) {
        this.searchForm.task_next_user_self = false
      }
    },
    task_next_user_change(val) {
      if (val) {
        this.searchForm.task_next_user_self = false
      }
    },
    decChange(val) {
      this.stopForm.note = val
    },
    async changeWorkingDate(val, currentRow, index) {
      // 工时列表 判断是否有重复的日期
      try {
        const { data } = await hoursList(this.taskId, this.type)
        const dates = data && data.length ? data.map(item => item.tt_coding_start_date) : []
        // 如果数组中当前日期超过两次，就提示
        // if (hasDates.filter(item => item === val).length > 1) {
        //   this.$message.error('该日期已选。')
        //   this.recordWorkingHours.domains[index].tt_coding_start_date = ''
        //   return
        // }
        if (dates.includes(val)) {
          this.$message.error('同一个任务在同一天只允许记录一次工时，如果工时有误，请在编辑工时处修改')
          this.disabledSaveWoringTimeBtn = true
        } else {
          this.disabledSaveWoringTimeBtn = false
        }
      } catch (error) {
        console.error(error);
      }
    },
    changeHours(val) {
      // 超过12 或者小于0，提示 一天工时不允许超过12小时
      if (this.inputHourValue > 12 || this.inputHourValue < 0) {
        this.$message({
          type: 'warning',
          message: '一天工时不允许超过12小时和小于1小时'
        })
      }
    },
    inputHours(val) {
      this.inputHourValue = val.target.value
    },
    datePickerFocus() {
      // 判断已填的数据是否有重复
      const hasDates = this.recordWorkingHours.domains.map(item => item.tt_coding_start_date)
      console.log(hasDates);
      this.pickerOptions.disabledDate = (time) => {
        // 排除已经填过的日期, 小于10 补0
        return hasDates.includes(
          `${time.getFullYear()}-${time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1}-${time.getDate() < 10 ? '0' + time.getDate() : time.getDate()}`
        )
      }
    },
    // 判断显示工时按钮
    /*
      task_status 0待开发 1开发中 2开发暂停 3待测试 4测试中 5测试暂停 6测试完成 7废弃 8关闭',
    */
    showWorkTimebtn(type, row) {
      if (row.demand_status === 13) return false
      const statusMap = {
        'coderTime': row.task_status !== 7 && row.task_status !== 0 && this.role.five == 5,
        'coderEditTime': row.task_status !== 7 && row.task_status !== 0 && this.role.four == 4,
        'testTime': [0, 1, 2, 3, 4, 5, 6].includes(row.task_status) && this.role.two == 2,
        'testEditTime': [0, 1, 2, 3, 4, 5, 6].includes(row.task_status) && this.role.three == 3,
      }
      return statusMap[type]
    },
    selectableFn(row, index) {
      return row.task_is_test === 1 || row.is_inform === 1
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.container {
  padding: 0 20px;

  .status {
    padding: 0px 0px 7px 0px;

    .el-tag {
      margin-right: 5px;
      margin-top: 5px;
      cursor: pointer;

      span {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }

  .editHours {
    padding: 0 50px;
  }

  .dialogBox {
    .el-select {
      width: 60%;
    }
  }

  .pageBox {
    text-align: center;
    margin-top: 10px;
  }

  // .moreSearch {
  //   display: inline-block;
  // }
  .edit-input {
    padding-right: 100px;
  }

  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }

  .blueTxt {
    color: #409eff;
  }
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}

.test_case_icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-color: red;
  color: white;
  text-align: center;
  line-height: 24px;
  padding: 0 1px;
  border-radius: 3px;
  margin-right: 5px;
}

.test_case_icon span {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  transform: scale(0.62);
  transform-origin: 0 50%;
  white-space: nowrap;
}

.tobottom {
  position: absolute;
  top: 40px;
  left: 180px;
}

.mark_title {
  display: inline-block;
  padding: 0 8px;
  font-size: 13px;
  color: #F56C6C;
  vertical-align: text-bottom;
}
</style>
